import {
  any, boolean, nullable, number,
  object, string,
} from '@sda/sdk/helpers/types.bitmasks';

export const PublicActMask = {
  actType: string,
  averageConnectionTime: number,
  badge: string | nullable,
  bioHTML: string,
  collaborators: any,
  city: string,
  compiledAddress: string,
  country: string,
  createdAt: any,
  hasFinishedShow: boolean,
  hasOtherAllergy: string,
  hasPetAllergy: boolean,
  facebookUrl: string,
  featuredReviewId: string | nullable,
  googlePlaceId: string,
  twitterUrl: string,
  instagramUrl: string,
  isRejected: boolean,
  latLng: any,
  musicTypes: any,
  name: string,
  numConnections: number,
  numReviews: number,
  otherActCanBeLocal: boolean,
  otherGenres: string,
  owner: string | nullable,
  performanceUrl: string,
  performanceUrlOld: string, // @todo: remove at some point
  primaryGenres: any, // deprecated
  primaryGenre: string,
  privateUpdatedAt: any,
  publicImageUrl: any | nullable,
  region: string | nullable,
  requiresBillet: boolean,
  requiresFood: boolean,
  requiresGreenRoom: boolean,
  requiresPA: boolean,
  reviewUrl: string,
  score: number,
  secondaryGenre: string,
  socialUrl: string,
  spotifyArtistUrl: string | nullable,
  spotifyGenres: any,
  spotifyMonthlyActiveListeners: number | nullable,
  spotifyPopularity: number | nullable,
  soundcloudUri: string | nullable,
  soundcloudUriCache: object | nullable,
  spotifyUri: string | nullable,
  spotifyUriCache: object | nullable,
  youtubeUri: string | nullable,
  youtubeUriCache: object | nullable,
  vimeoUri: string | nullable,
  vimeoUriCache: object | nullable,
  bandcampUri: string | nullable,
  bandcampUriCache: object | nullable,
  streamingUrl: string,
  technicalRequirements: string,
  vanityUrl: string,
  vanityUrlCache: any,
  vanityUrlLowercase: string,
  websiteUrl: string,
  updatedAt: any,
};
